function Board() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">GIMA Board</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default Board;